import { render, staticRenderFns } from "./QuestionImageButton.vue?vue&type=template&id=98d84870&scoped=true"
import script from "./QuestionImageButton.vue?vue&type=script&lang=js"
export * from "./QuestionImageButton.vue?vue&type=script&lang=js"
import style0 from "./QuestionImageButton.vue?vue&type=style&index=0&id=98d84870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d84870",
  null
  
)

export default component.exports